import { SearchHit } from '@features/search/search-hit';
import { IAsset } from '@imcc/transport';
import { buildProduct } from './build-product';
import { Download } from './download';
import { DownloadResolution } from './download-resolution';
import { GtmEvent } from './gtm-event-enum';
import { ProductProperties } from './product-properties';

function buildPurchase(downloadId: string, asset: ProductProperties) {
  const products = [buildProduct(asset)];

  return {
    actionField: { id: downloadId, revenue: '0' },
    dimension11: 'N/A',
    dimension12: 'N/A',
    products,
  };
}

export function buildDownload(
  event: GtmEvent.DirectDownload | GtmEvent.DirectDownloadHighres,
  asset: IAsset | SearchHit,
  downloadId: string,
): Download {
  const purchase = buildPurchase(downloadId, asset);

  if (event === GtmEvent.DirectDownload) {
    return {
      event,
      ecommerce: {
        purchase: {
          ...purchase,
          dimension10: DownloadResolution.Low,
        },
      },
    };
  }

  return {
    event,
    ecommerce: {
      purchase: {
        ...purchase,
        dimension10: DownloadResolution.High,
      },
    },
  };
}
